// import React from "react";

// function RegisterConfirm({ setActiveForm, source }) {
//   return (
//     <div className="max-716 w-100 rounded-1 border p-4 text-center">
//       <div className="font-24 font-700 mb-4 text-primary-green text-uppercase border-bottom pb-2">
//         Registration Successful
//       </div>

//       <div className="alert alert-success">
//         🎉 You have successfully registered and are now awaiting approval.  
//         Please check your email for further instructions.
//       </div>

//       <div className="mt-4">
//         <button
//           className="btn btn-primary-green height-50 max-165 px-5 text-white fw-normal rounded-1"
//           onClick={() => setActiveForm("login")}
//         >
//           Go to Login
//         </button>
//       </div>
//     </div>
//   );
// }

// export default RegisterConfirm;


import React from "react";

function RegisterConfirm({ setActiveForm, source }) {
  return (
    <div className="max-716 w-100 rounded-1 border p-4 text-center">
      <div className="font-24 font-700 mb-4 text-primary-green text-uppercase border-bottom pb-2">
        Registration Successful
      </div>

      <div className="alert alert-success">
        🎉 You have successfully registered and are now awaiting approval.  
        Please check your email for further instructions.
      </div>

      <div className="mt-4">
        <button
          className="btn btn-primary-green height-50 max-165 px-5 text-white fw-normal rounded-1"
          onClick={() => setActiveForm("login")}
        >
          Go to Login
        </button>
      </div>
    </div>
  );
}

export default RegisterConfirm;
